import React from "react";
import "./ContactSection.css";

export default function ContactSection() {
  return (
    <section id="contact" className="c-section">
      <div className="c-wrap">
        <header className="c-head">
          <p className="c-eyebrow">Get in touch</p>
          <h2 className="c-title">Get a Free Quote</h2>
          <p className="c-sub">
            Tell me a little about your project and I’ll get back to you ASAP.
          </p>
        </header>

        <div className="c-grid">
          {/* FORM */}
          <form
            className="c-card c-form"
            action="https://api.web3forms.com/submit"
            method="POST"
            encType="multipart/form-data"
          >
            {/* Web3Forms */}
            <input
              type="hidden"
              name="access_key"
              value="1a865d65-ef55-4c2b-b80b-3974ecbb49dd"
            />
            <input type="hidden" name="subject" value="New Inquiry — Northwoods Handy" />
            <input type="hidden" name="from_name" value="Northwoods Handy Website" />
            <input type="hidden" name="redirect" value="https://web3forms.com/success" />

            <div className="c-row">
              <div className="c-field">
                <label htmlFor="name">Full Name *</label>
                <input id="name" name="name" type="text" placeholder="Jane Doe" required />
              </div>

              <div className="c-field">
                <label htmlFor="phone">Phone *</label>
                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  inputMode="tel"
                  placeholder="(555) 123-4567"
                  pattern="^\+?[0-9\s\-\(\)]{7,}$"
                  required
                />
                <span className="c-help">Format like 555-123-4567</span>
              </div>
            </div>

            <div className="c-row">
              <div className="c-field">
                <label htmlFor="email">Email *</label>
                <input id="email" name="email" type="email" placeholder="you@example.com" required />
              </div>

              <div className="c-field">
                <label htmlFor="city">City *</label>
                <input id="city" name="city" type="text" placeholder="Your city" required />
              </div>
            </div>

            <div className="c-field">
              <label htmlFor="details">Tell me about your project *</label>
              <textarea
                id="details"
                name="project_details"
                placeholder="Briefly describe the work, location, and timing…"
                required
              />
            </div>

            <div className="c-actions">
              <button type="submit" className="c-cta">Send Request</button>
              <span className="c-note">I usually reply within 1 business day.</span>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}